import { EventEmitter } from "../main";

const types = { remindMe: "Reminde Me" };
const message = (type, data) => {
  switch (type) {
    case types.remindMe:
      return `${data.name}`;
  }
};

export default function pushNotification({
  task_id,
  project_id,
  getters,
  type,
  task,
  chat_id,
  comment,
  chat,
}) {
  let message_settings = {
    body: "",
    dir: "ltr",
    lang: "en-US",
    renotify: true,
  };

  let new_message = "";

  if (type == "remindMe") {
    if (!task) {
      task = getters.getTasks[project_id].find((task) => task._id == task_id);
    }

    if (!task || (task && task.done)) return;
    new_message = message(types.remindMe, task);
    message_settings.tag = "remind_" + task_id + "_notification";
    message_settings.body = "TaskPal reminder";
  }

  if (type == "mentionedInChat") {
    new_message = "Mentioned in Chat";
    message_settings.tag = "reply_" + chat_id + "_notification";
    message_settings.body = comment;
  }

  if (type == "addedToChat") {
    new_message = "TaskPal";
    message_settings.tag = "reply_" + chat_id + "_notification";
    message_settings.body = comment;
  }

  if (type == "mentionedInTask") {
    if (!task) {
      task = getters.getTasks[project_id].find((task) => task._id == task_id);
    }
    new_message = "Mentioned in Task " + task.name;
    message_settings.tag = "reply_" + task_id + "_notification";
    message_settings.body = comment;
  }

  if (type == "replyInTask") {
    if (!task) {
      task = getters.getTasks[project_id].find((task) => task._id == task_id);
    }
    new_message = "Reply in " + task.name;
    message_settings.tag = "reply_" + task_id + "_notification";
    message_settings.body = comment;
  }

  if (type == "replyInChat") {
    if (!chat) {
      chat = getters.getChats.find((chat) => chat._id == chat_id);
    }
    new_message = "Reply in " + chat.name;
    message_settings.tag = "reply_" + chat_id + "_notification";
    message_settings.body = comment;
  }

  if (!window.isElectronMac) {
    message_settings.icon = "/logo.png";
    message_settings.badge = "/logo.png";
  }

  let play_sound = true;

  if (window.isElectron) {
    message_settings.silent = true;
  } else {
    message_settings.vibrate = [100, 50, 200];
  }

  let message_notification = new Notification(new_message, message_settings);

  if (play_sound && !window.electron_dnd) {
    const nSound = new Audio("/sounds/notification.mp3");
    nSound.crossOrigin = "anonymous";
    nSound.play();
  }

  if (message_notification) {
    if (message_notification.onerror) {
      message_notification.onerror = (e) => {
        console.log("Error");
        console.log(e);
      };
    }
    message_notification.onclick = function (event) {
      window.focus();

      event.preventDefault(); // prevent the browser from focusing the Notification's tab

      if (window.isElectron) {
        window.focusElectron = true;
      }

      if (
        type == "remindMe" ||
        type == "mentionedInTask" ||
        type == "replyInTask"
      ) {
        EventEmitter.$emit(
          "openPushNotificationLink",
          `/project/${project_id}/task/${task_id}`
        );
        EventEmitter.$emit("openSubtask", task_id);
      } else if (type == "mentionedInChat" || type == "addedToChat") {
        EventEmitter.$emit("openPushNotificationLink", `/chats/${chat_id}/`);
        EventEmitter.$emit("changeSidebarTabs", "Chats");
        EventEmitter.$emit("changeTab", "Chats");
      }
    };
  }
}
